import { Button, feedbackcard, Icon } from '@yes.technology/react-toolkit'
import { useRef } from 'react'
import { useTranslation } from 'react-i18n-lite'
import { formatFileSize } from '../utils/formatFileSize'

const DEFAULT_FILE_SIZE_LIMIT = 10 * 1024 * 1024

interface FileUploaderProps {
  onChange?: (file: File) => void
  accept?: string
  maxSizeInBytes?: number
  variant?: 'primary' | 'secondary'
  style?: React.CSSProperties
}

const FileUploader = ({
  onChange,
  accept = '*',
  maxSizeInBytes,
  variant,
  style = { width: '40px', marginLeft: '4px' }
}: FileUploaderProps) => {
  const { t } = useTranslation()
  const hiddenFileInput = useRef<HTMLInputElement>(null)

  const handleClick = () => {
    hiddenFileInput.current?.click()
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileUploaded = event.target.files?.[0]

    if (fileUploaded) {
      const maxSize = maxSizeInBytes || DEFAULT_FILE_SIZE_LIMIT

      if (fileUploaded.size > maxSize) {
        feedbackcard(t('file-uploader.exceeds-limit-message.title'), {
          message: t('file-uploader.exceeds-limit-message.message', {
            maxSizeInBytes: formatFileSize(maxSize)
          }),
          type: 'error'
        })
        return
      }

      onChange?.(fileUploaded)
    }
  }

  return (
    <>
      <input
        type='file'
        ref={hiddenFileInput}
        onChange={handleChange}
        style={{ display: 'none' }}
        accept={accept}
        data-testid='file-input'
      />
      <Button onClick={handleClick} style={style} variant={variant}>
        <Icon iconName='DevicesLocal' icSize='semiSmall' />
      </Button>
    </>
  )
}

export default FileUploader
